export const ORIENTATIONS = [
  'ľavica',
  'stredoľavica',
  'stred',
  'stredopravica',
  'pravica',
  'krajná pravica',
] as const;

// Highest first.
export const OFFICES = [
  'Prezident',
  'Premiér',
  'Predseda NR SR',
  'Eurokomisár',
  'Minister',
  'Europoslanec',
  'Poslanec NR SR',
  'Iné',
] as const;

export const STATUSES = ['Prezident', 'Koalícia', 'Opozícia', 'EÚ', 'Mimo politiky'] as const;

export const REGIONS = [
  'Bratislavský',
  'Trnavský',
  'Trenčiansky',
  'Nitriansky',
  'Žilinský',
  'Banskobystrický',
  'Prešovský',
  'Košický',
  'Zahraničie',
] as const;

export type Gender = 'M' | 'F';
export type Orientation = (typeof ORIENTATIONS)[number];
export type Office = (typeof OFFICES)[number];
export type Status = (typeof STATUSES)[number];
export type Region = (typeof REGIONS)[number];

export interface Politician {
  id: string;
  name: string;
  wikidata: string;
  gender: Gender;
  born: string;
  died: string | null;
  birthplace: string;
  region: Region;
  party: string;
  partyHistory: string[];
  orientation: Orientation;
  office: Office;
  status: Status;
  image: string | null;
  /** First day (YYYY-MM-DD) this person can be a daily answer; missing = from launch. */
  added?: string;
  notes?: string;
}

export interface Credit {
  id: string;
  file: string;
  author: string;
  license: string;
  licenseUrl: string | null;
  sourceUrl: string;
}

export type Mode = 'classic' | 'photo';
